/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofileclose2Inputs */

const en_setupprofileclose2 = /** @type {(inputs: Setupprofileclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel setup`)
};

const de_setupprofileclose2 = /** @type {(inputs: Setupprofileclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtung abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel setup" |
*
* @param {Setupprofileclose2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofileclose2 = /** @type {((inputs?: Setupprofileclose2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofileclose2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofileclose2(inputs)
	return de_setupprofileclose2(inputs)
});
export { setupprofileclose2 as "setupProfileClose" }